import React, { useState } from "react";
import {
  IconCopy,
  IconUserAddPurple,
  IconUserPurple,
  USDTLogo,
} from "../Dashboard/dashboardIcons";
import { t } from "../../utils/i18n";

const SelectPaymentMethod = ({ referralCode, setSelectedPaymentMethod }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const copyToClipboard = () => {
    const addressInput = document.getElementById("tokenAddressInput");
    addressInput.select();
    navigator.clipboard.writeText(referralCode).then(
      () => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  const handleSelectUSD = () => {
    setSelectedPaymentMethod("USD");
    const currentPath = window.location.pathname;
    const newPath = `${currentPath}${
      currentPath.includes("?") ? "&" : "?"
    }payment_method=USD`;
    window.history.pushState({}, "", newPath);
  };

  return (
    <div className="card shadow-sm send-payment-card">
      <div className="card-header flex-column align-items-start">
        <h5 className="card-title mb-0 font-weight-bold">
          {t("wallets.send_payments.title")}
        </h5>
        <p className="m-0 my-1 font-0_85">
          {t("wallets.send_payments.subtitle")}
        </p>
      </div>
      <div className="transfer-options">
        <div
          className="transfer-option-wrapper option-account d-flex flex-row align-items-center"
          onClick={handleSelectUSD}
        >
          <div className="d-flex flex-row align-items-center">
            <div className="transfer-option-icon">
              <IconUserPurple height="3rem" width="3rem" />
            </div>
            <div className="pl-2">
              <p className="font-weight-bold m-0 my-1">
                {t("wallets.send_payments.send_to_account")}
              </p>
              <p className="m-0 my-1">
                <small>
                  {t("wallets.send_payments.send_to_account_desc")}
                  <br/>
                </small>
              </p>
            </div>
          </div>
          <div className="transfer-option-icon text-purple justify-self-end">
            <i className="fa fa-long-arrow-right"></i>
          </div>
        </div>
        <div className="transfer-option-wrapper option-invite d-flex flex-column">
          <div
            className="d-flex flex-row align-items-center justify-content-between"
            onClick={() => setSelectedOption("invite")}
          >
            <div className="d-flex flex-row align-items-center">
              <div className="transfer-option-icon">
                <IconUserAddPurple height="3rem" width="3rem" />
              </div>
              <div className="pl-2">
                <p className="font-weight-bold m-0 my-1">
                  {t("wallets.send_payments.invite_receiver")}
                </p>
                <p className="m-0 my-1">
                  <small>
                    {t("wallets.send_payments.invite_receiver_desc")}
                  </small>
                </p>
              </div>
            </div>
            <div className="transfer-option-icon text-purple">
              <i className="fa fa-long-arrow-right"></i>
            </div>
          </div>
          {selectedOption === "invite" && (
            <div className="option-drop">
              <p className="font-weight-bold font-0_8">
                {t("wallets.send_payments.copy_link")}
              </p>
              <div className="input-group mb-2 address-input-wrapper">
                <input
                  type="text"
                  className="form-control"
                  id="tokenAddressInput"
                  placeholder={t("wallets.send_payments.select_coin")}
                  value={referralCode}
                />
                <div className="drop-icon-wrapper">
                  <div className="address-copy-btn" onClick={copyToClipboard}>
                    {isCopied ? (
                      <>
                        {t("wallets.send_payments.copied")} <i className="fa fa-check"></i>
                      </>
                    ) : (
                      <>
                        {t("wallets.send_payments.copy")} <IconCopy />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="transfer-option-wrapper option-blockchain d-flex flex-column">
          <div
            className="d-flex flex-row align-items-center justify-content-between"
            onClick={() => setSelectedOption("blockchain")}
          >
            <div className="d-flex flex-row align-items-center">
              <div className="transfer-option-icon">
                <USDTLogo height="2.7rem" width="2.7rem" />
              </div>
              <div className="pl-2">
                <p className="font-weight-bold m-0 my-1">
                  {t("wallets.send_payments.send_usdt_polygon")}
                </p>
                <p className="m-0 my-1">
                  <small>
                    {t("wallets.send_payments.send_usdt_polygon_desc")}
                  </small>
                </p>
              </div>
            </div>
            <div className="transfer-option-icon text-purple">
              <i className="fa fa-long-arrow-right"></i>
            </div>
          </div>
          {selectedOption === "blockchain" && (
            <div className="option-drop">
              <p className="font-weight-bold font-0_9">
                <i className="fa fa-info-circle"></i> {t("wallets.send_payments.only_send")}
              </p>
              <p className="font-0_8">
                {t("wallets.send_payments.loss_warning")}
                <br/>
                <b>{t("wallets.send_payments.note")}</b> {t("wallets.send_payments.setup_fee")}
              </p>
              <a
                class="btn btn-primary btn-purple mb-2 w-100"
                type="submit"
                href="/crypto_transfers/send_crypto/blockchain_transfer"
              >
                {t("wallets.send_payments.send_usdt")} <i className="fa fa-arrow-right"></i>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectPaymentMethod;
